var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFutr = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.27 12h4.07v-2H7.27v-.93a5 5 0 019.57-2.2l1.8-.87a7.11 7.11 0 00-2.55-2.86A7 7 0 005.27 9.07V15h2v-3m7.09-1a1.5 1.5 0 103 0 1.5 1.5 0 10-3 0m2.52 6.05a5.06 5.06 0 01-7.33 2.06A5.1 5.1 0 017.71 17l-1.81.83a7.13 7.13 0 002.56 3A7.06 7.06 0 0018.68 18l-1.8-.86"
})));

export default SvgIconFutr;